import { useEffect, useState } from 'react';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import stylesMobile from '../Components/styles/InventoryOverviewMobile.module.scss';
import PersonPopup from './PersonPopup';
import { fetchCompetencyInfo, CompetencyInfoMap } from '@behavior/persons/competencyApi';

type Props = {
  personList: any[];
  isMobile: boolean;
  showPersonalData?: boolean;
};

const PersonPopupWrapper = ({ personList, isMobile, showPersonalData }: Props) => {
  const [competencyInfoMap, setCompetencyInfoMap] = useState<CompetencyInfoMap>({});

  useEffect(() => {
    if (personList.length > 0) {
      const personIds = personList.map((p: any) => p.id).filter(Boolean);
      if (personIds.length > 0) {
        fetchCompetencyInfo(personIds).then(setCompetencyInfoMap);
      }
    }
  }, [personList]);

  if (personList.length > 0) {
    return (
      <div className={styles.contactSimplifiedView}>
        <h4
          className={
            isMobile
              ? `${stylesMobile.contactElements} ${styles.h4}`
              : `${styles.inlineElements} ${styles.h4}`
          }
        ></h4>
        {personList.map(contact => (
          <PersonPopup
            contact={contact}
            showPersonalData={showPersonalData}
            showWarningIfPersonNotAtCern
            showWarning={competencyInfoMap[contact.id]?.isMissingCompetency}
          />
        ))}
      </div>
    );
  } else {
    return <></>;
  }
};

PersonPopupWrapper.defaultProps = {
  isMobile: false,
};

export default PersonPopupWrapper;
